import { BookOpen } from "lucide-react";
import { getPreachingRosters } from "@/lib/api";

const preachingProvider = {
  id: "predicacion",
  label: "Predicación",
  icon: BookOpen,
  iconBg: "bg-emerald-50",
  iconColor: "text-emerald-600",
  fields: ["title", "date_start", "date_end"],
  load: (districtId) => getPreachingRosters(districtId),
  buildItem: (r) => ({
    id: r.id,
    title: r.title || "Rol de predicación",
    subtitle: r.date_start ? `${r.date_start} – ${r.date_end}` : "",
    route: `/preaching/${r.id}`,
    recent: null,
  }),
};

export default preachingProvider;
